import { render } from "./ZoomableImage.vue?vue&type=template&id=14b71ef8&scoped=true"
import script from "./ZoomableImage.vue?vue&type=script&lang=js"
export * from "./ZoomableImage.vue?vue&type=script&lang=js"

import "./ZoomableImage.vue?vue&type=style&index=0&id=14b71ef8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b71ef8"]])

export default __exports__